import React from 'react';

const Logout = () => {
  return (
    <>
      <h1 data-testid="logout-text">You are logged out</h1>
    </>
  );
};

export default Logout;
